/**
 * What comes after the first game, without inventing any of it.
 *
 * Four steps on a dashed line, in the order that makes sense, each described
 * as work rather than as a release. There are no dates here because there are
 * no dates.
 */

import { useI18n } from "../../i18n";
import { Motif } from "../art/Motif";
import type { MotifId } from "@kikik/game-catalog";

const ITEMS: readonly { key: "item1" | "item2" | "item3" | "item4"; motif: MotifId }[] = [
  { key: "item1", motif: "board" },
  { key: "item2", motif: "confetti" },
  { key: "item3", motif: "cards" },
  { key: "item4", motif: "flask" },
];

export function NextSection() {
  const { t } = useI18n();

  return (
    <section className="section section--next" aria-labelledby="next-title" data-reveal="out">
      <div className="shell">
        <p className="eyebrow">{t("portal.next.eyebrow")}</p>
        <h2 className="section__title" id="next-title">
          {t("portal.next.title")}
        </h2>
        <p className="section__lead">{t("portal.next.lead")}</p>

        <ol className="roadmap">
          {ITEMS.map((item) => (
            <li key={item.key} className="roadmap__item">
              <span className="roadmap__node" aria-hidden="true">
                <Motif motif={item.motif} />
              </span>
              <h3 className="roadmap__title">{t(`portal.next.${item.key}.title`)}</h3>
              <p className="roadmap__body">{t(`portal.next.${item.key}.body`)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
